import db from "utils/localstorage";

export default {
  namespaced: true,
  state: {
    sidebar: {
      opened: true
    },
    settingBar: {
      opened: false
    },
    isMobile: false,
    theme: db.get("THEME", "light"),
    layout: db.get("LAYOUT", "side"),
    systemName: "燃气监测预警云平台",
    systemIcon: "static/img/DefaultSystemLogo.png",
    copyright: `${new Date().getFullYear()} <a href="https://mrbird.cc" target="_blank">MrBird</a>`,
    multipage: getBooleanValue(db.get("MULTIPAGE"), false),
    fixSiderbar: getBooleanValue(db.get("FIX_SIDERBAR"), true),
    fixHeader: getBooleanValue(db.get("FIX_HEADER"), false),
    colorList: [
      "rgb(245, 34, 45)",
      "rgb(250, 84, 28)",
      "rgb(250, 173, 20)",
      "rgb(66, 185, 131)",
      "rgb(82, 196, 26)",
      "rgb(24, 144, 255)",
      "#004290",
      "rgb(47, 84, 235)",
      "rgb(114, 46, 209)"
    ],
    color: db.get("COLOR", "#004290"),
    mapRefresh: false,
    defaultMap: db.get("defaultMap") || 0
  },
  mutations: {
    setDevice(state, isMobile) {
      state.isMobile = isMobile;
    },
    setTheme(state, theme) {
      db.save("THEME", theme);
      state.theme = theme;
    },
    setLayout(state, layout) {
      db.save("LAYOUT", layout);
      state.layout = layout;
    },
    setMultipage(state, multipage) {
      let multipages = multipage == 1 ? true : false;
      db.save("MULTIPAGE", multipages);
      state.multipage = multipages;
    },
    setSidebar(state, type) {
      state.sidebar.opened = type;
    },
    fixSiderbar(state, flag) {
      db.save("FIX_SIDERBAR", flag);
      state.fixSiderbar = flag;
    },
    fixHeader(state, flag) {
      db.save("FIX_HEADER", flag);
      state.fixHeader = flag;
    },
    setSettingBar(state, flag) {
      state.settingBar.opened = flag;
    },
    setColor(state, color) {
      db.save("COLOR", color);
      state.color = color;
    },
    setMapRefresh(state, refresh) {
      state.mapRefresh = refresh;
    },
    setSystemName(state, name) {
      state.systemName = name;
    },
    setDefaultMap(state, defaultMap) {
      db.save("defaultMap", defaultMap);
      state.defaultMap = defaultMap;
    },
    setSystemIcon(state, icon) {
      state.systemIcon = icon
    }
  }
};

function getBooleanValue(value, defaultValue) {
  if (Object.is(value, null)) {
    return defaultValue;
  }
  if (JSON.stringify(value) !== "{}") {
    return value;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js